<template>
    <div>
        <img class="recruit-bannerImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/t-banner.png" alt="">
        <div class="recruit-banner">
            <div class="recruit-banner-title">招生牛人</div>
            <div class="recruit-banner-title2">覆盖教育机构全部经营环节</div>
            <div class="recruit-banner-title2" style="margin-bottom: 80px;">提供全方位解决方案</div>
            <div class="im-bannerInfo-BtnBox">
                <div @click="gowe" class="im-bannerInfo-Btn">了解更多</div>
                <div  @click="popshow = true" class="im-bannerInfo-Btn2">试用</div>
            </div>
        </div>
        <div class="recruit-cont-box">
            <div class="recruit-cont-box-l">
                <img style="margin-right: 170px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/t-extension.png" alt="">
            </div>
            <div class="recruit-cont-box-r">
                <div class="recruit-cont-box-title">招生拓客</div>
                <div class="recruit-cont-box-title2">提供全渠道全场景招生营销方案，实现招生获客的持续增长</div>
                <div class="recruit-cont-box-cbg" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/t-extension-t1.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title">内容营销</div>
                        <div class="recruit-cont-box-cbg-title2">线上利用平台或发放图文/资料包等形式吸引流量；</div>
                        <div class="recruit-cont-box-cbg-title2">线下以各种活动、渠道/销售、地推等方法获取流量</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg" >
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/t-extension-t2.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title">活动营销</div>
                        <div class="recruit-cont-box-cbg-title2">通过各种形式营销活动助力获客，获客数据精细化管</div>
                        <div class="recruit-cont-box-cbg-title2">理，让活动效果有据可依</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg" style="margin-bottom: 100px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/t-extension-t3.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title">社交营销</div>
                        <div class="recruit-cont-box-cbg-title2">裂变场景多样化，裂变优惠券、好友瓜分券等多种裂</div>
                        <div class="recruit-cont-box-cbg-title2">变营销方法，实现低成本、高效率、指数级用户增长。</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="down-arrow">
            <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/down-arrow.png" alt="">
        </div>
        <div class="recruit-cont-box" style="justify-content: flex-start">
            <div class="recruit-cont-box-l" >
                <img style="margin-right: 60px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/t-clue.png" alt="">
            </div>
            <div class="recruit-cont-box-r">
                <div class="recruit-cont-box-title">线索管理</div>
                <div class="recruit-cont-box-title2">重塑线索管理系统，大幅提升招生转化率</div>
                <div class="recruit-cont-box-cbg recruit-cont-box-dp" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 32px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-hook.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">线索自动分类，灵活分配，提升线索跟进、流转效率</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg recruit-cont-box-dp" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 32px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-hook.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">不断进行线索孵化，提高流量池用户 — 试听 — 转化</div>
                        <div class="recruit-cont-box-cbg-title2">— 正课的转化效率</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg recruit-cont-box-dp" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 32px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-hook.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">为客户打上标签，便于分析客户行为，采取不同跟进</div>
                        <div class="recruit-cont-box-cbg-title2">方式，提高转化效率</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="down-arrow">
            <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/down-arrow.png" alt="">
        </div>
        <div class="recruit-cont-box" style="justify-content: flex-start;margin-bottom: 122px;">
            <div class="recruit-cont-box-l" >
                <img style="margin-right: 83px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/t-analysis.png" alt="">
            </div>
            <div class="recruit-cont-box-r">
                <div class="recruit-cont-box-title">智能分析</div>
                <div class="recruit-cont-box-title2">通过数据分析为决策者提供全面的数据支持，实现精准营销</div>
                <div class="recruit-cont-box-cbg recruit-cont-box-dp2" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 32px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-hook.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r" style="width: 500px;">
                        <div class="recruit-cont-box-cbg-title2">创建多维度用户画像，明确用户需求与关注重点，深度分析用户特性；</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg recruit-cont-box-dp2" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 32px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-hook.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r" style="width: 500px;">
                        <div class="recruit-cont-box-cbg-title2">筛选用户群体，追踪、分析、留存潜客，根据用户兴趣及关注重点进行精准</div>
                        <div class="recruit-cont-box-cbg-title2">营销；</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg recruit-cont-box-dp2" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 32px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/et-hook.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r" style="width: 500px;">
                        <div class="recruit-cont-box-cbg-title2">根据数据分析结果，在活动时间内用户达到触发条件时，系统自动推送营销</div>
                        <div class="recruit-cont-box-cbg-title2">内容，并根据营销结果优化营销方案，实现全自动营销，帮助企业快速孵化</div>
                        <div class="recruit-cont-box-cbg-title2">线索，提高线索转化率；</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="popshow" class="pop-bg">
            <div class="pop">
                <img class="pop-logo" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/popup-t1.png" alt="">
                <div class="pop-title">产品试用请联系</div>
                <div class="pop-title2-box">
                    <div class="pop-title2-box-l">
                        <img class="pop-logo2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/popup-t2.png" alt="">
                        <div>手机号：</div>
                    </div>
                    <div class="pop-title2-box-r">15900622304</div>
                </div>
                <div class="pop-title2-box" style="margin-bottom: 38px;">
                    <div class="pop-title2-box-l">
                    </div>
                    <div class="pop-title2-box-r">18862561723</div>
                </div>
                <div class="pop-title2-box">
                    <div class="pop-title2-box-l">
                        <img class="pop-logo2" style="width: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/mailbox.png" alt="">
                        <div>邮箱：</div>
                    </div>
                    <div class="pop-title2-box-r">jenny.wang@unishining.com</div>
                </div>
                <div class="pop-title2-box">
                    <div class="pop-title2-box-l">
                    </div>
                    <div class="pop-title2-box-r">Diana.wu@unishining.com</div>
                </div>
                <div @click="popshow = false" class="pop-out">知道了</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "education-recruit",
        data:vm=>{
            return{
                popshow:false
            }
        },
        methods:{
            gowe(){
                this.$router.push('/we')
            },
        }
    }
</script>

<style lang="less" scoped>
html{
    overflow-x:hidden;
}
.recruit-bannerImg{
    position: absolute;
    right: 0px;
    top: 61px;
    width: 990px;
}
.recruit-banner{
    position: relative;
    z-index: 1;
    margin: 7px auto 240px auto;
    width: 1200px;
    box-sizing: border-box;
    padding-top: 80px;
    .recruit-banner-title{
        font-size: 32px;
        font-weight: bold;
        margin-bottom: 37px;
    }
    .recruit-banner-title2{
        font-size: 28px;
        font-weight: 300;
        margin-bottom: 5px;
    }
    .im-bannerInfo-BtnBox{
        display: flex;
        align-items: center;
        .im-bannerInfo-Btn{
            font-size: 16px;
            color: #636363;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 161px;
            height: 47px;
            border: 1px solid #313131;
            cursor: pointer;
        }
        .im-bannerInfo-Btn2{
            width: 161px;
            height: 47px;
            border: 1px solid #313131;
            background: #1B1B1B;
            font-size: 16px;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 20px;
            cursor: pointer;
        }
    }
}
.recruit-cont-box{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .recruit-cont-box-title{
        font-size: 32px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .recruit-cont-box-title2{
        font-size: 20px;
        font-weight: 300;
    }
    .recruit-cont-box-cbg{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 50px;
        .recruit-cont-box-cbg-title{
            font-size: 20px;
            margin-bottom: 13px;
        }
        .recruit-cont-box-cbg-title2{
            color: #636363;
            font-size: 14px;
        }
        .recruit-cont-box-cbg-r{
            width: 336px;
        }
    }
    .recruit-cont-box-dp{
        display: flex;
        align-items: flex-start;
        .recruit-cont-box-cbg-l{
            display: flex;
            align-items: flex-start;
        }
    }
    .recruit-cont-box-dp2{
        display: flex;
        align-items: flex-start;
        .recruit-cont-box-cbg-l{
            display: flex;
            align-items: flex-start;
        }
    }
    .recruit-cont-box-r{

    }
}
.down-arrow{
    width: 1200px;
    margin: 70px auto;
    text-align: center;
}
.pop-bg{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 99999;
    background: rgba(0,0,0,.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .pop{
        width: 395px;
        height: 502px;
        background: #FFFFFF;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .pop-logo{
            margin-bottom: 17px;
        }
        .pop-title{
            font-size: 20px;
            color: #000000;
            margin-bottom: 55px;
        }
        .pop-title2-box{
            display: flex;
            width: 350px;
            .pop-title2-box-l{
                width: 96px;
                font-size: 16px;
                display: flex;
                align-items: center;
                .pop-logo2{
                    margin-right: 11px;
                }
            }
            .pop-title2-box-r{
                color: #B10515;
                font-size: 18px;
            }
        }
        .pop-out{
            width: 172px;
            height: 45px;
            background: #B10515;
            border-radius: 23px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-size: 16px;
            cursor: pointer;
            margin-top: 70px;
        }
    }
}
</style>